/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_box_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Each column of numbers becomes one box summarising that group.`)
};

const es_box_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada columna de números se convierte en una caja que resume ese grupo.`)
};

const de_box_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jede Zahlenspalte wird zu einer Box, die diese Gruppe zusammenfasst.`)
};

const nl_box_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elke kolom getallen wordt één box die die groep samenvat.`)
};

const fr_box_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chaque colonne de nombres devient une boîte résumant ce groupe.`)
};

const it_box_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ogni colonna di numeri diventa una scatola che riassume quel gruppo.`)
};

const pt_br2_box_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada coluna de números se torna uma caixa resumindo aquele grupo.`)
};

const pt_box_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada coluna de números torna-se uma caixa que resume esse grupo.`)
};

const ja_box_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数値の各列が、そのグループを要約する1つの箱になります。`)
};

const zh_box_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每列数字生成一个概括该组数据的箱子。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const box_ex1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.box_ex1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("box_ex1", locale)
	if (locale === "en") return en_box_ex1(inputs)
	if (locale === "es") return es_box_ex1(inputs)
	if (locale === "de") return de_box_ex1(inputs)
	if (locale === "nl") return nl_box_ex1(inputs)
	if (locale === "fr") return fr_box_ex1(inputs)
	if (locale === "it") return it_box_ex1(inputs)
	if (locale === "pt-BR") return pt_br2_box_ex1(inputs)
	if (locale === "pt") return pt_box_ex1(inputs)
	if (locale === "ja") return ja_box_ex1(inputs)
	return zh_box_ex1(inputs)
};